<template>
  <v-container  fluid class="pa-0">
    <PageHeader title="Files" icon="collections" />
    <Subheader dense title="Browse By Monitoring Component" no-search />

    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6 md3 class="my-3" v-for="stn in sortedStationCategories" :key="stn.Name">
          <TileNavigationButton :title="stn.Name" :icon="stn.IconPath" @click.native="viewTile(stn.Name)" />
          <!-- <v-card hover ripple tile class="dashboard-tile" :to="'datasets/browse'" @click.prevent="viewTile(stn.Name)">
            <v-card-title>
              <v-icon left>{{ stn.IconPath }}</v-icon>
              {{ stn.Name }}
            </v-card-title>
          </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider />

    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6 lg4 class="my-3">
          <TileNavigationButton dark color="success" title="Browse All Files" icon="perm_media" @click.native="viewAll()" />
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider />

    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6 lg4 class="my-3">
          <TileNavigationButton dark color="warning" title="Recycle Bin" icon="mdi-recycle" @click.native="viewRecycleBin()" />
        </v-flex>
      </v-layout>
    </v-container>

  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'

  import TileNavigationButton from '@/components/generic/navigation/TileNavigationButton'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    StationCategoryFilter,
  } from '@/components/plugins/DataSetFilter'

  const stations = createNamespacedHelpers('stations')
  const datasetfilter = createNamespacedHelpers('datasetfilter')

  export default {
    components: {
      PageHeader,
      Subheader,
      TileNavigationButton,
    },
    data() {
      return {}
    },
    computed: {
      ...stations.mapGetters(['stationCategories']),
      ...datasetfilter.mapGetters(['getSubmittedFilters']),
      sortedStationCategories() {
        if (this.stationCategories == null) {
          return []
        }
        return this.stationCategories
          .sort((a, b) => (a.Name > b.Name ? 1 : -1))
          .map(e => {
            return {
              Name: e.Name,
              IconPath: e.IconPath,
            }
          })
      },
    },
    methods: {
      ...datasetfilter.mapActions(['addFilter', 'submitFilters']),
      ...datasetfilter.mapMutations({
        clearFilters: 'ClearFilters',
      }),
      viewTile(stationName) {
        this.clearFilters()
        this.addFilter(new StationCategoryFilter(stationName))
        this.submitFilters()
        this.redirect()
      },
      viewAll() {
        this.clearFilters()
        this.redirect()
      },
      viewRecycleBin() {
        this.clearFilters()
        var filter = {
          config: { params: { limit: 5, offset: 0, sortBy: 'DateCreated', descending: true, page: 1 } },
          forced: false,
          data: this.getSubmittedFilters || {
            MatchValuesFilters: [],
            MatchRangeFilters: [],
            TimeRangeFilters: [],
            FileNameFilters: [],
          },
        }
        this.$router.push('/datasets/recyclebin?filter=' + encodeURIComponent(window.btoa(JSON.stringify(filter))))
      },
      redirect() {
        var filter = {
          config: { params: { limit: 5, offset: 0, sortBy: 'DateCreated', descending: true, page: 1 } },
          forced: false,
          data: this.getSubmittedFilters || {
            MatchValuesFilters: [],
            MatchRangeFilters: [],
            TimeRangeFilters: [],
            FileNameFilters: [],
          },
        }
        this.$router.push('/datasets/browse?filter=' + encodeURIComponent(window.btoa(JSON.stringify(filter))))
      },
    },
  }
</script>


<style lang="stylus" scoped>
  div.station-category-name {
    overflow-wrap: break-word;
  }

  div.dashboard-tile {
    height: 100%;
    width: 100%;
  }

  .my-3 {
    cursor: pointer
  }
</style>
